import { useRef } from "react";
import { useSessionTimer } from "./useSessionTimer";
export function useAnalytics() {
    var products = useRef([]);
    var languages = useRef([]);
    var productsSubsidiary = useRef([]);
    var internalTraffic = useRef(false);
    var statusRef = useRef();
    var duration = useRef("");
    var os = useRef("");
    var subsidiary = useRef("");
    var getDuration = useSessionTimer().getDuration;
    function trackProduct(name) {
        if (!name)
            return;
        var existing = products.current.find(function (p) { return p.product === name; });
        if (existing) {
            existing.clickCount += 1;
        }
        else {
            products.current.push({ product: name, clickCount: 1 });
        }
    }
    function trackLanguage(lang) {
        if (!lang)
            return;
        var existing = languages.current.find(function (l) { return l.lang === lang; });
        if (existing) {
            existing.clickCount += 1;
        }
        else {
            languages.current.push({ lang: lang, clickCount: 1 });
        }
    }
    function setOS(value) {
        os.current = value;
    }
    function setSubsidiary(value) {
        subsidiary.current = value;
    }
    function formatStreamStatus(status) {
        switch (status) {
            case "New":
            case "Checking":
                return "visite non commencee";
            case "Closed":
            case "Withdrawn":
                return "erreur pendant la visite";
            case "Completed":
            case "Connected":
                return "oui";
            case "Disconnected":
                return "deconnecte de la visite";
            case "Failed":
                return "erreur pendant la connexion";
            case "NotSupported":
                return "non supporte";
            default:
                return "inconnu";
        }
    }
    function saveAnalytics() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var date = new Date().toLocaleDateString("fr-FR");
        var heure = new Date().toLocaleTimeString("fr-FR");
        var streamStatus = formatStreamStatus(statusRef.current);
        var internal = internalTraffic.current ? "interne" : "externe";
        duration.current = getDuration(statusRef.current);
        var productsList = products.current;
        var languagesList = languages.current;
        var maxLength = Math.max(productsList.length, languagesList.length);
        var rows = [];
        var _loop_1 = function (i) {
            var isFirstRow = i === 0;
            var product = (_b = (_a = productsList[i]) === null || _a === void 0 ? void 0 : _a.product) !== null && _b !== void 0 ? _b : "";
            var productNb = (_d = (_c = productsList[i]) === null || _c === void 0 ? void 0 : _c.clickCount) !== null && _d !== void 0 ? _d : "";
            var lang = (_f = (_e = languagesList[i]) === null || _e === void 0 ? void 0 : _e.lang) !== null && _f !== void 0 ? _f : "";
            var langNb = (_h = (_g = languagesList[i]) === null || _g === void 0 ? void 0 : _g.clickCount) !== null && _h !== void 0 ? _h : "";
            var filiale = (_k = (_j = productsSubsidiary.current.find(function (p) { return p.product === product; })) === null || _j === void 0 ? void 0 : _j.filiale) !== null && _k !== void 0 ? _k : "";
            rows.push([
                isFirstRow ? date : "",
                isFirstRow ? heure : "",
                isFirstRow ? streamStatus : "",
                isFirstRow ? internal : "",
                isFirstRow ? duration.current : "",
                isFirstRow ? os.current : "",
                isFirstRow ? subsidiary.current : "",
                product,
                productNb,
                filiale,
                lang,
                langNb,
            ]);
        };
        for (var i = 0; i < maxLength; i++) {
            _loop_1(i);
        }
        var csv = rows.map(function (row) { return row.join(","); }).join("\n");
        var formData = new FormData();
        formData.append("data", csv);
        fetch("./index.php", {
            method: "POST",
            body: formData,
        })
            .then(function () {
            console.log("[CSV upload] done");
        })
            .catch(function (err) {
            console.error(err);
        });
    }
    return {
        trackProduct: trackProduct,
        trackLanguage: trackLanguage,
        saveAnalytics: saveAnalytics,
        setOS: setOS,
        setSubsidiary: setSubsidiary,
        products: products,
        languages: languages,
        productsSubsidiary: productsSubsidiary,
        internalTraffic: internalTraffic,
        statusRef: statusRef,
    };
}
